export default __webpack_public_path__ + "static/case-logo-3-5e5cccd800b23225328ae5bc4c2e361c.webp";